import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtSGT } from "@/lib/api";

export function AdminSubmissions() {
  const [subs, setSubs] = useState([]);
  const [day, setDay] = useState("");
  const [totalDays, setTotalDays] = useState(7);
  useEffect(() => { api.get("/admin/season").then(({ data }) => setTotalDays(data.total_days)).catch(() => {}); }, []);
  useEffect(() => {
    api.get("/admin/submissions", { params: day ? { day } : {} }).then(({ data }) => setSubs(data)).catch((e) => toast.error(errMsg(e)));
  }, [day]);
  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <p className="eyebrow" data-testid="admin-submission-count">{subs.length} submissions</p>
        <select className="field w-28 py-2 text-sm" value={day} onChange={(e) => setDay(e.target.value)} data-testid="admin-submissions-day-filter">
          <option value="">All days</option>
          {Array.from({ length: totalDays }, (_, i) => i + 1).map((d) => <option key={d} value={d}>{`Day ${d}`}</option>)}
        </select>
      </div>
      <ul className="panel divide-y divide-slate-800" data-testid="admin-submission-list">
        {subs.length === 0 && <li className="p-4 text-sm text-slate-500">No submissions yet.</li>}
        {subs.map((s) => (
          <li key={s.id} className="flex items-center justify-between gap-3 px-4 py-3" data-testid={`admin-submission-${s.id}`}>
            <div className="min-w-0">
              <p className="truncate text-sm font-medium">{s.display_name} · D{s.day} C{s.challenge_number}</p>
              <p className="text-xs text-slate-500">{s.status} · {s.selected_index != null ? "ABCD"[s.selected_index] : "—"} · set time {s.response_ms != null ? `${(s.response_ms / 1000).toFixed(0)}s` : "…"} · {fmtSGT(s.submitted_at || s.started_at)}</p>
            </div>
            <span className={`font-mono text-sm font-bold ${s.is_correct ? "text-emerald-400" : s.status === "started" ? "text-slate-500" : "text-rose-400"}`}>{s.status === "started" ? "open" : `+${s.points_awarded}`}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
